/* eslint-disable camelcase, no-undef */
// https://github.com/rails/webpacker/issues/2269
if(window.__webpackPublicPath) { __webpack_public_path__ = window.__webpackPublicPath; }
